import { IonBadge, IonButton, IonButtons, IonContent, IonFooter, IonHeader, IonIcon, IonLoading, IonMenuButton, IonModal, IonPage, IonTextarea, IonTitle, IonToast, useIonViewDidEnter } from '@ionic/react';
import { arrowBack, arrowForwardOutline, calendarOutline, chatbubbles, chatbubblesOutline, checkmarkOutline, chevronDownOutline, copy, informationCircleOutline, notifications, timeOutline, warningOutline } from 'ionicons/icons';
import React, { useContext, useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import ModalHeader from '../../../../../components/Modal/ModalHeader';
import IonToolbar from '../../../../../components/Modal/ModalToolbar';

import OnboardingHomeBanner from '../../../../../components/Onboarding/OnboardingHomeBanner';
import WelcomeModal from '../../../../../components/Onboarding/WelcomeModal';
import { MessageContext } from '../../../../../contexts/MessageContext';
import { OnboardingContext } from '../../../../../contexts/OnboardingContext';
import logoXeguei from '../../../../../theme/icons/LogoCor.png';
import { getPlanos, onboardingBuscar, onboardingIniciar, pagamentoMensalidade, requestService, usuariosAlterarPin } from '../../../../../Utils/Services';
import Menu from '../../Components/Menu';
import Notificacoes from '../Notificacoes/Notificacoes';
import CriarPinModal from './CriarPinModal';
import './Inicio.css';
import InicioPainel, { InicioSuporte } from './InicioPainel';
import useResumoDia from './useResumoDia';
import { podeVerResumo } from './resumoDia';
import './Pagamentos.css';
import ModuloPlanoCard, { obterModulosContratados } from './ModuloPlanoCard';

type Props = {
  abrirMenu: boolean;
};

const Inicio: React.FC<Props> = (props: Props) => {
  const history = useHistory();
  const [showLoadingPage, setShowLoadingPage] = useState(false);

  const { loja, setLoja } = useContext(MessageContext);
  const [acessos] = useState<any>(JSON.parse(window.localStorage.getItem("acessos") || '{}'));
  const { esconderMenu, setEsconderMenu } = useContext(MessageContext);
  const { nomeMenu, setNomeMenu } = useContext(MessageContext);
  const { notificacoes, setNotificacoes } = useContext(MessageContext);
  const [showNotificacoes, setShowNotificacoes] = useState(false);
  const { mensagens, setMensagens } = useContext(MessageContext);

  const [mostrarRecursosPlano, setMostrarRecursosPlano] = useState(false);
  const [showModalPlanos, setShowModalPlanos] = useState(false);
  const [showModalAvisoPagamento, setShowModalAvisoPagamento] = useState(false);
  const [planos, setPlanos] = useState<any[]>([]);
  const [planoBase, setPlanoBase] = useState<any>(null);
  const [modulosDisponiveis, setModulosDisponiveis] = useState<any[]>([]);
  const [modulosContratados, setModulosContratados] = useState<string[]>([]);
  const [modulosSelecionados, setModulosSelecionados] = useState<string[]>([]);
  const [dadosEmpresaPlanos, setDadosEmpresaPlanos] = useState<any>(null);
  const [loadingPlanos, setLoadingPlanos] = useState(false);
  const [showModalQrCode, setShowModalQrCode] = useState(false);
  const [qrCodeData, setQRCodeData] = useState<any>();
  const [qrCode, setQRCode] = useState<any>();
  const { idPagamento, setIdPagamento } = useContext(MessageContext);
  const { isPaymentCompleted, setIsPaymentCompleted } = useContext(MessageContext);
  const [valorPagamento, setValorPagamento] = useState<any>();
  const [showToast, setShowToast] = useState(false);
  const [textToast, setTextToast] = useState("");
  const { dadosEmpresa, setDadosEmpresa } = useContext(MessageContext);
  const { onboardingData, setOnboardingData, onboardingCarregado, setOnboardingCarregado, setEtapaAtual } = useContext(OnboardingContext);
  const [showWelcomeModal, setShowWelcomeModal] = useState(false);
  const [timeLeft, setTimeLeft] = useState(6 * 60);
  const [showModalPin, setShowModalPin] = useState(false);
  const [pin, setPin] = useState(['', '', '', '']);
  const [confirmPin, setConfirmPin] = useState(['', '', '', '']);
  const [etapaPin, setEtapaPin] = useState(1);
  const [erroPin, setErroPin] = useState(false);
  const [pendingWelcomeModal, setPendingWelcomeModal] = useState(false);
  const tempoRestantePagamento = dadosEmpresa?.tempoRestanteParaPagamento;
  const diferencaDataPagamento = dadosEmpresa?.diferencaDataPagamento;
  const diasVencidosPagamento = diferencaDataPagamento !== null && diferencaDataPagamento !== undefined
    ? Number(diferencaDataPagamento)
    : Number.NaN;
  const diasRestantesPagamento = dadosEmpresa?.bloquearAcesso && Number.isFinite(diasVencidosPagamento)
    ? -Math.abs(diasVencidosPagamento)
    : tempoRestantePagamento !== null && tempoRestantePagamento !== undefined
      ? Number(tempoRestantePagamento)
      : Number.NaN;
  const deveExibirAvisoPagamento = Boolean(
    dadosEmpresa
    && Number.isFinite(diasRestantesPagamento)
    && diasRestantesPagamento <= 5
    && dadosEmpresa.pk === dadosEmpresa.gsi3pk
  );

  const mostrarResumo = podeVerResumo(acessos) && !dadosEmpresa?.bloquearAcesso;
  const resumoDia = useResumoDia(loja, mostrarResumo);
  const exibirFaixaPagamento = dadosEmpresa && Object.keys(dadosEmpresa).length > 0
    && !(dadosEmpresa.tempoRestanteParaPagamento > 20 || dadosEmpresa.pk != dadosEmpresa.gsi3pk);
  const avisoPagamento = !exibirFaixaPagamento ? undefined : dadosEmpresa.bloquearAcesso
    ? "Seu acesso foi bloqueado. Realize o pagamento para continuar utilizando nossos serviços."
    : (dadosEmpresa.tempoRestanteParaPagamento || 0) === 0
      ? "Sua licença vence hoje. Realize o pagamento para manter o acesso."
      : dadosEmpresa.tempoRestanteParaPagamento === 1
        ? "Sua licença vence em 1 dia."
        : `Sua licença vence em ${dadosEmpresa.tempoRestanteParaPagamento || 0} dias.`;

  useIonViewDidEnter(() => {
    setEsconderMenu(false);
    setNomeMenu("");
    setEtapaAtual(null);

    if (loja) {
      const url = onboardingBuscar.url.replace('{empresa_id}', encodeURIComponent(loja));
      requestService(url, { method: onboardingBuscar.method }, history,
        (response: any) => {
          setOnboardingCarregado(true);
          if (response.exists === false || !response.empresa_id) {
            const pinJaCadastrado = window.localStorage.getItem("pinCadastrado") === "true";
            if (pinJaCadastrado) {
              setShowWelcomeModal(true);
            } else {
              setPendingWelcomeModal(true);
            }
          } else {
            setOnboardingData(response);
          }
        },
        (error: any) => {
          console.log('Erro ao carregar onboarding:', error);
          setOnboardingCarregado(true);
        }
      );
    }

    const pinCadastrado = window.localStorage.getItem("pinCadastrado");
    if (pinCadastrado && pinCadastrado === "true") {
      console.log("PIN já cadastrado");
    } else {
      setShowModalPin(true);
    }

    setShowModalAvisoPagamento(deveExibirAvisoPagamento);
  });

  useEffect(() => {
    setShowModalAvisoPagamento(deveExibirAvisoPagamento);
  }, [deveExibirAvisoPagamento]);

  async function carregarPlanos() {
    setLoadingPlanos(true);
    setPlanoBase(null);
    setPlanos([]);
    setModulosDisponiveis([]);
    setModulosSelecionados([]);
    setModulosContratados([]);
    setDadosEmpresaPlanos(null);
    try {
      var token: string = "";
      var tkn = localStorage.getItem("token");
      if (typeof (tkn) === "string") { token = tkn; }
      let resp = await fetch(getPlanos.url, {
        method: getPlanos.method,
        headers: [["token", token]],
        credentials: 'include'
      });
      let retorno = await resp.json();
      if (resp.status === 200) {
        if (retorno.planoBase) {
          setPlanoBase(retorno.planoBase);
          const modulos = retorno.modulos || [];
          setModulosDisponiveis(modulos);
          const contratados = obterModulosContratados(modulos, retorno.dadosEmpresa?.modulos ?? dadosEmpresa?.modulos);
          setModulosContratados(contratados);
          setModulosSelecionados(contratados);
          setDadosEmpresaPlanos(retorno.dadosEmpresa || null);
        }
        if (retorno.planos) { setPlanos(retorno.planos); }
      } else {
        setTextToast("Erro ao carregar planos. Tente novamente.");
        setShowToast(true);
      }
    } catch (error) {
      setTextToast("Erro ao carregar planos. Tente novamente.");
      setShowToast(true);
    } finally {
      setLoadingPlanos(false);
    }
  }

  async function abrirPlanosPagamento() {
    setShowModalAvisoPagamento(false);
    setShowModalPlanos(true);
    await carregarPlanos();
  }

  function gerarCompraCanonica(modulosSel: string[]): string {
    const temRobo = modulosSel.includes("robo_whatsapp_ia");
    const temFiscal = modulosSel.includes("modulo_fiscal");
    if (temRobo && temFiscal) return "mensalidade_robo_fiscal";
    if (temRobo) return "mensalidade_robo";
    if (temFiscal) return "mensalidade_fiscal";
    return "mensalidade";
  }

  function calcularTotalDinamico(modulosSel: string[]): number {
    if (!planoBase) return 0;
    const quantLojas = (dadosEmpresaPlanos && dadosEmpresaPlanos.quantidadeLojas) || 1;
    // planoBase.valor já vem do backend multiplicado por quantidadeLojas
    // Os módulos são valores unitários (por loja), então precisam ser multiplicados
    let total = planoBase.valor || 0;
    for (const modId of modulosSel) {
      const mod = modulosDisponiveis.find((m: any) => m.id === modId);
      if (mod) total += (mod.valor || 0) * quantLojas;
    }
    return parseFloat(total.toFixed(2));
  }

  async function closeModalNotificacoes() { setShowNotificacoes(false); }
  async function closeModalSimpleNotificacoes() { setShowNotificacoes(false); }

  const handleOnboardingIniciar = () => {
    const url = onboardingIniciar.url.replace('{empresa_id}', encodeURIComponent(loja));
    requestService(url, { method: onboardingIniciar.method }, history,
      (response: any) => { setOnboardingData(response); setShowWelcomeModal(false); history.push('/empresa/configuracao-inicial'); },
      (error: any) => { console.log('Erro ao iniciar onboarding:', error); setShowWelcomeModal(false); }
    );
  };

  const handleOnboardingFecharModal = () => {
    const url = onboardingIniciar.url.replace('{empresa_id}', encodeURIComponent(loja));
    requestService(url, { method: onboardingIniciar.method }, history,
      (response: any) => { setOnboardingData(response); setShowWelcomeModal(false); },
      (error: any) => { console.log('Erro ao criar registro onboarding:', error); setShowWelcomeModal(false); }
    );
  };

  function isSequencial(pinArray: string[]) {
    if (pinArray.length < 2) return false;
    let isAsc = true; let isDesc = true;
    for (let i = 1; i < pinArray.length; i++) {
      const prev = parseInt(pinArray[i - 1], 10); const curr = parseInt(pinArray[i], 10);
      if (isNaN(prev) || isNaN(curr)) return false;
      if (curr !== prev + 1) isAsc = false;
      if (curr !== prev - 1) isDesc = false;
    }
    return isAsc || isDesc;
  }

  function hasMoreThan3Equal(pinArray: string[]) {
    let count = 1;
    for (let i = 1; i < pinArray.length; i++) {
      if (pinArray[i] === pinArray[i - 1]) { count++; if (count > 3) return true; } else { count = 1; }
    }
    return false;
  }

  const avancarParaConfirmacao = () => {
    if (!pin.every(digit => digit !== '')) { setTextToast("Por favor, preencha todos os 4 dígitos do PIN."); setShowToast(true); return; }
    if (isSequencial(pin)) { setTextToast("O PIN não pode ser sequencial."); setShowToast(true); return; }
    if (hasMoreThan3Equal(pin)) { setTextToast("O PIN não pode ter mais de 3 dígitos iguais em sequência."); setShowToast(true); return; }
    setEtapaPin(2);
    setTimeout(() => { const f = document.getElementById('confirm-pin-input-0'); if (f) (f as HTMLInputElement).focus(); }, 100);
  };

  const salvarPin = async () => {
    if (!confirmPin.every(digit => digit !== '')) { setTextToast("Por favor, preencha todos os 4 dígitos de confirmação."); setShowToast(true); return; }
    const pinString = pin.join(''); const confirmPinString = confirmPin.join('');
    if (pinString !== confirmPinString) {
      setTextToast("Os PINs não conferem. Tente novamente."); setShowToast(true); setErroPin(true); setConfirmPin(['', '', '', '']);
      setTimeout(() => setErroPin(false), 500);
      setTimeout(() => { const f = document.getElementById('confirm-pin-input-0'); if (f) (f as HTMLInputElement).focus(); }, 100);
      return;
    }
    try {
      setShowLoadingPage(true);
      const objeto = { pk: loja, pin: pinString };
      const resp = await fetch(usuariosAlterarPin.url.replace("{pk}", btoa(objeto.pk)), {
        method: usuariosAlterarPin.method,
        headers: [["token", localStorage.getItem("token") || ""]],
        credentials: 'include',
        body: JSON.stringify(objeto)
      });
      if (resp.status === 200) {
        window.localStorage.setItem("pinCadastrado", "true");
        setTextToast("PIN cadastrado com sucesso! Use-o no próximo acesso."); setShowToast(true); setShowModalPin(false);
        if (pendingWelcomeModal) { setPendingWelcomeModal(false); setShowWelcomeModal(true); }
      } else { setTextToast("Erro ao cadastrar PIN. Tente novamente."); setShowToast(true); }
    } catch (error) { setTextToast("Erro ao cadastrar PIN. Tente novamente."); setShowToast(true); }
    finally { setShowLoadingPage(false); }
  };

  const voltarParaCriacao = () => {
    setEtapaPin(1); setConfirmPin(['', '', '', '']);
    setTimeout(() => { const f = document.getElementById('pin-input-0'); if (f) (f as HTMLInputElement).focus(); }, 100);
  };

  useEffect(() => {
    if (isPaymentCompleted && showModalQrCode) { setShowModalQrCode(false); setIsPaymentCompleted(false); }
  }, [isPaymentCompleted]);

  useEffect(() => {
    if (showModalPin) { setTimeout(() => { const f = document.getElementById('pin-validacao-input-0'); if (f) (f as HTMLInputElement).focus(); }, 300); }
  }, [showModalPin]);

  useEffect(() => {
    let timer: NodeJS.Timeout;
    if (showModalQrCode) {
      setTimeLeft(6 * 60);
      timer = setInterval(() => {
        setTimeLeft(prevTime => {
          if (prevTime > 0) return prevTime - 1;
          clearInterval(timer); handleQrCodeExpired(); return 0;
        });
      }, 1000);
    }
    return () => clearInterval(timer);
  }, [showModalQrCode]);

  const handleQrCodeExpired = () => {
    setTextToast("Código expirado. Gere um novo para efetuar o pagamento."); setShowToast(true); setShowModalQrCode(false);
  };

  const minutes = Math.floor(timeLeft / 60);
  const seconds = timeLeft % 60;

  return (
    <>
      <Menu id="main-content-inicio"></Menu>
      <IonPage id="main-content-inicio" className="Inicio">
        <IonHeader>
          <IonToolbar color="primary">
            <IonButtons slot="start"><IonMenuButton /></IonButtons>
            <IonTitle>Início</IonTitle>
            <IonButtons slot="end">
              <IonButton onClick={() => setShowNotificacoes(true)}>
                <IonIcon slot="icon-only" icon={notifications} />
                <IonBadge id="cart-badge" color="danger">{notificacoes?.length}</IonBadge>
              </IonButton>
            </IonButtons>
            <IonButtons slot="end" hidden={acessos?.chat != 'leitura' && acessos?.chat != 'edicao'}>
              <IonButton onClick={() => history.push("./chat")}>
                <IonIcon slot="icon-only" icon={chatbubbles} />
                <IonBadge id="cart-badge" color="danger">{mensagens?.length}</IonBadge>
              </IonButton>
            </IonButtons>
          </IonToolbar>

        </IonHeader>

        <IonContent fullscreen={false}>
          <InicioSuporte />

          {/* Conteúdo centralizado e suporte fixo fora da área de rolagem. */}
          <div className="inicio-content-wrapper">
            <div className="inicio-inner">

              <InicioPainel
                nome={window.localStorage.getItem('nome') || ''}
                acessos={acessos}
                bloqueado={Boolean(dadosEmpresa?.bloquearAcesso)}
                mesas={window.localStorage.getItem('nomeInternoMesasOuComandas') || 'Mesas'}
                pedidos={window.localStorage.getItem('servicoTipoPlural') || 'Projetos'}
                onNavigate={rota => history.push(rota)}
                avisoPagamento={avisoPagamento}
                onPagamento={abrirPlanosPagamento}
                mostrarResumo={mostrarResumo}
                resumo={resumoDia.resumo}
                carregando={resumoDia.carregando}
                erro={resumoDia.erro}
                dia={resumoDia.dia}
                onAtualizar={resumoDia.atualizar}
                onboarding={onboardingData && !onboardingData.onboarding_concluido ? (
                  <OnboardingHomeBanner
                    porcentagem={onboardingData.porcentagem}
                    totalEtapas={onboardingData.total_etapas}
                    etapasConcluidas={onboardingData.etapas.filter((e: any) => e.status === 'concluido').length}
                    onClick={() => history.push('/empresa/configuracao-inicial')}
                  />
                ) : null}
              />


            </div>
          </div>

          {/* Onboarding Welcome Modal */}
          <WelcomeModal isOpen={showWelcomeModal} onClose={handleOnboardingFecharModal} onStart={handleOnboardingIniciar} />

          <div className="content">
            {/* Aviso de vencimento próximo ou em atraso */}
            <IonModal
              className="aviso-pagamento-modal"
              isOpen={deveExibirAvisoPagamento && showModalAvisoPagamento && !showModalPin && !showWelcomeModal}
              backdropDismiss={false}
              onDidDismiss={() => setShowModalAvisoPagamento(false)}
            >
              <div className={`aviso-pagamento-painel ${diasRestantesPagamento < 0 ? 'is-overdue' : ''}`}>
                <ModalHeader title="Aviso de pagamento" layout="compact" onDismiss={() => setShowModalAvisoPagamento(false)} />
                <div className="aviso-pagamento-conteudo">
                  <div className="aviso-pagamento-icone" aria-hidden="true">
                    <IonIcon icon={warningOutline} />
                  </div>
                  <h2>{diasRestantesPagamento < 0 ? "Pagamento vencido" : diasRestantesPagamento === 0 ? "Sua licença vence hoje" : "Sua licença vence em breve"}</h2>
                  <p className="aviso-pagamento-prazo">
                    {diasRestantesPagamento < 0
                      ? Math.abs(diasRestantesPagamento) === 1
                        ? "Sua licença venceu há 1 dia."
                        : `Sua licença venceu há ${Math.abs(diasRestantesPagamento)} dias.`
                      : diasRestantesPagamento === 0
                        ? "Sua licença vence hoje."
                        : diasRestantesPagamento === 1
                          ? "Falta 1 dia para o vencimento da sua licença."
                          : `Faltam ${diasRestantesPagamento} dias para o vencimento da sua licença.`}
                  </p>
                  <p>
                    {dadosEmpresa.bloquearAcesso
                      ? "Realize o pagamento para recuperar seu acesso aos recursos do Xeguei."
                      : "Realize o pagamento para não ficar sem acesso aos recursos do Xeguei."}
                  </p>
                </div>
                <footer className="aviso-pagamento-acoes">
                  <IonButton className="aviso-pagamento-secundario" fill="outline" onClick={() => setShowModalAvisoPagamento(false)}>
                    Fechar
                  </IonButton>
                  <IonButton className="aviso-pagamento-primario" onClick={abrirPlanosPagamento}>
                    Realizar pagamento
                  </IonButton>
                </footer>
              </div>
            </IonModal>

            <CriarPinModal
              isOpen={showModalPin}
              step={etapaPin}
              error={erroPin}
              busy={showLoadingPage}
              onDidDismiss={() => setShowModalPin(false)}
              onBack={voltarParaCriacao}
              onPinChange={v => { const a = v.split(''); while (a.length < 4) a.push(''); setPin(a.slice(0, 4)); }}
              onConfirmChange={v => { const a = v.split(''); while (a.length < 4) a.push(''); setConfirmPin(a.slice(0, 4)); }}
              onNext={avancarParaConfirmacao}
              onSave={salvarPin}
            />

            {/* Planos e pagamento: apresentação responsiva; regras de compra preservadas. */}
            <IonModal className="fullscreen-modal pagamentos-modal pagamentos-planos-modal" isOpen={showModalPlanos} onDidDismiss={() => setShowModalPlanos(false)}>
              <ModalHeader title="Monte seu plano" subtitle="Escolha os adicionais para o seu negócio." onDismiss={() => setShowModalPlanos(false)} />
              <IonContent className="pagamentos-content">
                <div className="pagamentos-container">
                  {loadingPlanos ? (
                    <IonLoading isOpen={loadingPlanos} message="Carregando planos..." />
                  ) : planoBase ? (
                    <>
                      <div className="pagamentos-planos">
                        <section className="pagamentos-base">
                          <div className="pagamentos-base-faixa">
                            <div className="pagamentos-base-identidade">
                              <img src={logoXeguei} alt="" className="pagamentos-base-logo" />
                              <div>
                                <h3>{planoBase.titulo}</h3>
                                {planoBase.subtitulo && <p className="pagamentos-subtitulo">{planoBase.subtitulo}</p>}
                              </div>
                            </div>
                            <div className="pagamentos-base-valor">
                              <p className="pagamentos-preco">{planoBase.valorFormatado}<span> /mês</span></p>
                              {planoBase.percentualDesconto > 0 && <p className="pagamentos-desconto">Desconto de {planoBase.percentualDescontoFormatado} aplicado!</p>}
                            </div>
                            <span className="pagamentos-badge">Plano base</span>
                            {planoBase.recursos?.length > 0 && (
                              <button className="pagamentos-ver-recursos" type="button" aria-expanded={mostrarRecursosPlano} aria-controls="pagamentos-recursos-base" onClick={() => setMostrarRecursosPlano(!mostrarRecursosPlano)}>
                                {mostrarRecursosPlano ? 'Ocultar recursos' : 'Ver todos os recursos'}
                                <IonIcon icon={chevronDownOutline} aria-hidden="true" />
                              </button>
                            )}
                          </div>
                          {!(planoBase.percentualDesconto > 0) && <p className="pagamentos-oferta">Quer pagar menos? Garanta seu desconto{' '}<a href="#" onClick={(e) => { e.preventDefault(); window.open("https://api.whatsapp.com/send?phone=5511963927646&text=Gostaria de obter meu desconto na mensalidade do xeguei", "_blank"); }}>aqui!</a></p>}
                          <div id="pagamentos-recursos-base" hidden={!mostrarRecursosPlano}>
                            <ul className="pagamentos-recursos pagamentos-base-recursos">
                              {planoBase.recursos && planoBase.recursos.map((r: string, i: number) => <li key={i}><IonIcon icon={checkmarkOutline} aria-hidden="true" /><span>{r}</span></li>)}
                            </ul>
                          </div>
                        </section>
                        {modulosDisponiveis.length > 0 && (
                          <section className="pagamentos-adicionais">
                            <h3 className="pagamentos-section-title">Adicionais</h3>
                            <div className="pagamentos-modulos">
                              {modulosDisponiveis.map((modulo: any) => (
                                <ModuloPlanoCard
                                  key={modulo.id}
                                  modulo={modulo}
                                  selecionado={modulosSelecionados.includes(modulo.id)}
                                  ativo={modulosContratados.includes(modulo.id)}
                                  onToggle={() => setModulosSelecionados(prev => prev.includes(modulo.id)
                                    ? prev.filter(id => id !== modulo.id)
                                    : [...prev, modulo.id])}
                                />
                              ))}
                            </div>
                            <p className="pagamentos-selecao-ajuda"><IonIcon icon={informationCircleOutline} aria-hidden="true" />Selecione os adicionais que deseja incluir no seu plano.</p>
                          </section>
                        )}
                      </div>
                    </>
                  ) : (
                    <div className="pagamentos-legado">
                      {planos.map((plano: any) => (
                        <section key={plano.id} className={`pagamentos-card ${plano.destaque ? 'is-selected' : ''}`}>
                          <div className="pagamentos-card-heading">
                            <h3>{plano.titulo}</h3>
                            {plano.destaque && <span className="pagamentos-badge">Recomendado</span>}
                          </div>
                          {plano.subtitulo && <p className="pagamentos-subtitulo">{plano.subtitulo}</p>}
                          {plano.valorFormatado && <p className="pagamentos-preco">{plano.valorFormatado}{plano.recorrencia && <span> /{plano.recorrencia}</span>}</p>}
                          {plano.descricao && <p className="pagamentos-subtitulo">{plano.descricao}</p>}
                          {plano.recursos && plano.recursos.length > 0 && <ul className="pagamentos-recursos">{plano.recursos.map((r: string, i: number) => <li key={i}>{r}</li>)}</ul>}
                          <IonButton className="pagamentos-botao" expand="block" fill={plano.destaque ? 'solid' : 'outline'} onClick={async () => {
                                  if (plano.contemContato) { window.open("https://api.whatsapp.com/send?phone=5511963927646&text=Olá! Gostaria de saber mais sobre o plano Multi Lojas.", "_blank"); return; }
                                  var token = localStorage.getItem("token") || "";
                                  const objectRequest = plano.tipo ? { compra: plano.tipo } : undefined;
                                  let resp = await fetch(pagamentoMensalidade.url.replace("{id}", loja.replaceAll(/#/g, "%23")), { method: pagamentoMensalidade.method, headers: [["token", token]], body: objectRequest ? JSON.stringify(objectRequest) : undefined, credentials: 'include' });
                                  let retorno = await resp.json();
                                  if (resp.status === 400 || resp.status === 401) { setTextToast("Ocorreu um erro ao gerar o Pagamento, entre em contato com o suporte."); setShowToast(true); }
                                  else if (retorno.message) { setIdPagamento(retorno.message.id); setQRCode(retorno.message.point_of_interaction.transaction_data.qr_code); setQRCodeData(retorno.message.point_of_interaction.transaction_data.qr_code_base64); setValorPagamento(retorno.message.transaction_amount); setShowModalPlanos(false); setShowModalQrCode(true); }
                                  else { setTextToast("Ocorreu um erro ao gerar o Pagamento, entre em contato com o suporte."); setShowToast(true); }
                                }}>{plano.contemContato ? 'Falar com especialista' : 'Selecionar'}</IonButton>
                        </section>
                      ))}
                    </div>
                  )}
                </div>
              </IonContent>
              {planoBase && (
                <IonFooter className="ion-no-border pagamentos-footer">
                  <div className="pagamentos-resumo">
                    <div className="pagamentos-total">
                      <div><span>Total mensal</span><strong aria-live="polite">R$ {calcularTotalDinamico(modulosSelecionados).toFixed(2).replace('.', ',')}<small>/mês</small></strong></div>
                      {dadosEmpresaPlanos && dadosEmpresaPlanos.quantidadeLojas > 1 && <p>Valor referente a {dadosEmpresaPlanos.quantidadeLojas} lojas.</p>}
                    </div>
                    <IonButton className="pagamentos-botao" expand="block" onClick={async () => {
                      var token = localStorage.getItem("token") || "";
                      const compraCanonica = gerarCompraCanonica(modulosSelecionados);
                      const quantLojas = (dadosEmpresaPlanos && dadosEmpresaPlanos.quantidadeLojas) || 1;
                      const objectRequest = { compra: compraCanonica, modulos: modulosSelecionados, quantidadeLojas: quantLojas, metodoPagamento: "pix" };
                      let resp = await fetch(pagamentoMensalidade.url.replace("{id}", loja.replaceAll(/#/g, "%23")), { method: pagamentoMensalidade.method, headers: [["token", token]], body: JSON.stringify(objectRequest), credentials: 'include' });
                      let retorno = await resp.json();
                      if (resp.status === 400 || resp.status === 401) { setTextToast("Ocorreu um erro ao gerar o Pagamento, entre em contato com o suporte."); setShowToast(true); }
                      else if (retorno.message) { setIdPagamento(retorno.message.id); setQRCode(retorno.message.point_of_interaction.transaction_data.qr_code); setQRCodeData(retorno.message.point_of_interaction.transaction_data.qr_code_base64); setValorPagamento(retorno.message.transaction_amount); setShowModalPlanos(false); setShowModalQrCode(true); }
                      else { setTextToast("Ocorreu um erro ao gerar o Pagamento, entre em contato com o suporte."); setShowToast(true); }
                    }}>Pagar via Pix<IonIcon icon={arrowForwardOutline} slot="end" aria-hidden="true" /></IonButton>
                  </div>
                </IonFooter>
              )}
            </IonModal>

            <IonModal className="fullscreen-modal pagamentos-modal pagamentos-pix-modal" isOpen={showModalQrCode} onDidDismiss={() => { setShowModalQrCode(false); setIdPagamento(""); }}>
              <IonHeader className="ion-no-border">
                <IonToolbar>
                  <IonButtons slot="start" data-modal-navigation="previous">
                    <IonButton aria-label="Voltar aos planos" onClick={() => { setShowModalQrCode(false); setShowModalPlanos(true); setIdPagamento(""); }}>
                      <IonIcon slot="icon-only" icon={arrowBack} />
                    </IonButton>
                  </IonButtons>
                  <IonTitle><h2>Detalhes do pagamento</h2><p>Finalize a assinatura com Pix.</p></IonTitle>
                </IonToolbar>
              </IonHeader>
              <IonContent className="pagamentos-content">
                <div className="pagamentos-container pagamentos-pix">
                  <section className="pagamentos-base pagamentos-pix-resumo">
                    <div className="pagamentos-base-identidade">
                      <img src={logoXeguei} alt="" className="pagamentos-base-logo" />
                      <div><h3>Assinatura Xeguei</h3><p className="pagamentos-subtitulo">Pagamento via Pix</p></div>
                    </div>
                    <div className="pagamentos-pix-valor"><span>Valor a pagar</span><p className="pagamentos-preco">R$ {valorPagamento?.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</p></div>
                  </section>
                  <div className="pagamentos-pix-opcoes">
                    <section className="pagamentos-card pagamentos-pix-qr">
                      <h3>Escaneie o QR Code</h3>
                      <p className="pagamentos-subtitulo">Use o aplicativo do seu banco para pagar.</p>
                      {qrCodeData && <img className="pagamentos-qrcode" src={`data:image/png;base64,${qrCodeData}`} alt="QR Code para pagamento via Pix" />}
                    </section>
                    <div className="pagamentos-pix-alternativa">
                      <section className="pagamentos-card pagamentos-pix-codigo">
                        <h3>Ou copie o código Pix</h3>
                        <p className="pagamentos-subtitulo">Cole o código na opção Pix Copia e Cola do seu banco.</p>
                        <IonTextarea id="pagamentos-pix-code" aria-label="Código de pagamento" className="pagamentos-code" readonly={true} rows={2} value={qrCode} />
                        <IonButton className="pagamentos-botao" expand="block" onClick={() => { navigator.clipboard.writeText(qrCode); setTextToast("Código copiado"); setShowToast(true); }}>
                          <IonIcon slot="start" icon={copy} />Copiar código Pix
                        </IonButton>
                      </section>
                      <section className="pagamentos-pix-instrucoes">
                        <h3>Como pagar?</h3>
                        <ol>
                          <li>Abra o aplicativo do seu banco e escolha Pix.</li>
                          <li>Escaneie o QR Code ou use Pix Copia e Cola.</li>
                          <li>Confirme no banco e aguarde o processamento.</li>
                        </ol>
                      </section>
                    </div>
                  </div>
                </div>
              </IonContent>
              <IonFooter className="ion-no-border pagamentos-footer">
                <div className="pagamentos-pix-rodape">
                  <span><IonIcon icon={timeOutline} aria-hidden="true" />Código válido por</span>
                  <strong>{minutes}:{seconds < 10 ? `0${seconds}` : seconds}</strong>
                </div>
              </IonFooter>
            </IonModal>

            <IonModal isOpen={showNotificacoes} onDidDismiss={() => setShowNotificacoes(false)}>
              <Notificacoes closeAction={closeModalNotificacoes} closeActionSimple={closeModalSimpleNotificacoes} />
            </IonModal>
          </div>

          <IonToast isOpen={showToast} position="middle" onDidDismiss={() => setShowToast(false)} message={textToast} duration={3000} />
          <IonLoading cssClass='my-custom-class' isOpen={showLoadingPage} onDidDismiss={() => setShowLoadingPage(false)} spinner='circles' />
        </IonContent>
      </IonPage>
    </>
  );
};

export default Inicio;
